import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e15cdf50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mypage py-3" }
const _hoisted_2 = { class: "section px-3 pt-4 mt-2" }
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_4 = { class: "text-mild text-size-26 text-weight-500 py-3" }
const _hoisted_5 = { class: "text-size-12 py-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "bg-white border border-outline-color px-3 pb-3 mt-1 round-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-21 text-weight-500 py-3" }, "\n                退会理由を選択してください\n              ", -1))
const _hoisted_9 = { class: "m-2" }
const _hoisted_10 = { class: "bg-white border border-outline-color px-3 mt-1 round-4 pb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-21 text-weight-500 py-3" }, "\n                当サービスにはどの程度ご満足いただけましたか？\n              ", -1))
const _hoisted_12 = { class: "bg-white border border-outline-color px-3 pb-2 mt-1 round-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-21 text-weight-500 py-3" }, "\n                当社のサービスをどのように知りましたか？\n              ", -1))
const _hoisted_14 = { class: "m-2" }
const _hoisted_15 = { class: "bg-white border border-outline-color px-3 pb-2 mt-1 round-4" }
const _hoisted_16 = { class: "text-mild text-size-21 text-weight-500 py-3" }
const _hoisted_17 = { class: "d-inline-flex w-100 justify-content-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_FormInvalidFeedback = _resolveComponent("FormInvalidFeedback")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_AppTextField = _resolveComponent("AppTextField")!
  const _component_FormRadioGroup = _resolveComponent("FormRadioGroup")!
  const _component_TextAreaGroup = _resolveComponent("TextAreaGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      退会アンケート\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
          default: _withCtx(({ handleSubmit }) => [
            _createVNode(_component_BForm, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, "\n                [" + _toDisplayString(_ctx.serviceName) + "] 退会アンケート\n              ", 1),
                  _createTextVNode(),
                  _createElementVNode("p", _hoisted_5, [
                    _createTextVNode("\n                この度はワークシェアサービス[" + _toDisplayString(_ctx.serviceName) + "]をご利用いただき、心\n                よりお礼申し上げます。貴方様のニーズを叶えられるように、今後も日々改\n                善していきます。", 1),
                    _hoisted_6,
                    _createTextVNode("\n                今後のサービス運営の参考にさせていただきますので、以下のアンケートに\n                ご協力いただけますと幸いです。\n              ")
                  ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(),
                  _createVNode(_component_AppLabel, { variant: "red" }, {
                    default: _withCtx(() => [
                      _createTextVNode("必須")
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_ValidationProvider, {
                    name: "退会理由",
                    rules: { at_latest_one: _ctx.inputValue.selectedLeaveReason },
                    vid: "inputValue.selectedLeaveReason"
                  }, {
                    default: _withCtx((validationState) => [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaveReasons, (option, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: option.id,
                            class: "d-flex"
                          }, [
                            _createVNode(_component_AppCheckbox, {
                              modelValue: _ctx.inputValue.selectedLeaveReason[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.inputValue.selectedLeaveReason[index]) = $event),
                              id: `q1-option-${option.id}`,
                              name: "退会理由",
                              class: "mt-1 checkbox",
                              text: option.text
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "text"])
                          ]))
                        }), 128))
                      ]),
                      _createTextVNode(),
                      _createVNode(_component_FormInvalidFeedback, {
                        "validation-state": validationState,
                        state: false
                      }, null, 8, ["validation-state"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createTextVNode(),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ValidationProvider, {
                      name: "退会理由(その他)",
                      rules: {
                    max: 20,
                    required: _ctx.isSelected(_ctx.inputValue.selectedLeaveReason[6])
                  },
                      vid: "inputValue.otherLeaveReason"
                    }, {
                      default: _withCtx((validationState) => [
                        _createVNode(_component_AppTextField, {
                          modelValue: _ctx.inputValue.otherLeaveReason,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue.otherLeaveReason) = $event)),
                          name: "退会理由(その他)"
                        }, null, 8, ["modelValue"]),
                        _createTextVNode(),
                        _createVNode(_component_FormInvalidFeedback, {
                          "validation-state": validationState,
                          state: false
                        }, null, 8, ["validation-state"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ], 512), [
                    [_vShow, _ctx.isSelected(_ctx.inputValue.selectedLeaveReason[6])]
                  ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(),
                  _createVNode(_component_ValidationProvider, {
                    name: "満足度",
                    rules: "required",
                    vid: "inputValue.selectedSatisfactionRate"
                  }, {
                    default: _withCtx((validationState) => [
                      _createVNode(_component_FormRadioGroup, {
                        appLabelText: "必須",
                        name: "satisfaction-rate",
                        modelValue: _ctx.inputValue.selectedSatisfactionRate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue.selectedSatisfactionRate) = $event)),
                        options: _ctx.satisfactionRate,
                        "validation-state": validationState,
                        size: "small",
                        "has-border": false,
                        "flex-direction": "column"
                      }, null, 8, ["modelValue", "options", "validation-state"])
                    ]),
                    _: 1
                  })
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(),
                  _createVNode(_component_ValidationProvider, {
                    name: "知った理由",
                    rules: "required",
                    vid: "inputValue.selectedKnewReason"
                  }, {
                    default: _withCtx((validationState) => [
                      _createVNode(_component_FormRadioGroup, {
                        appLabelText: "必須",
                        name: "knew-reason",
                        modelValue: _ctx.inputValue.selectedKnewReason,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValue.selectedKnewReason) = $event)),
                        options: _ctx.knewReasons,
                        "validation-state": validationState,
                        size: "small",
                        "has-border": false,
                        "flex-direction": "column"
                      }, null, 8, ["modelValue", "options", "validation-state"]),
                      _createTextVNode(),
                      _withDirectives(_createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ValidationProvider, {
                          name: "サービスを知った理由",
                          rules: {
                      max: 20,
                      required: _ctx.inputValue.selectedKnewReason === '12'
                    },
                          vid: "inputValue.otherKnewReason"
                        }, {
                          default: _withCtx((validationState) => [
                            _createVNode(_component_AppTextField, {
                              modelValue: _ctx.inputValue.otherKnewReason,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue.otherKnewReason) = $event)),
                              name: "サービスを知った理由"
                            }, null, 8, ["modelValue"]),
                            _createTextVNode(),
                            _createVNode(_component_FormInvalidFeedback, {
                              "validation-state": validationState,
                              state: false
                            }, null, 8, ["validation-state"])
                          ]),
                          _: 2
                        }, 1032, ["rules"])
                      ], 512), [
                        [_vShow, _ctx.inputValue.selectedKnewReason === '12']
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.serviceName) + "に対して今後のサービス改善のため、ご意見・ご要望をお書きください\n              ", 1),
                  _createTextVNode(),
                  _createVNode(_component_ValidationProvider, {
                    name: "テキスト",
                    rules: { max: 200, min: 20, required: true },
                    vid: "inputValue.suggestionValue"
                  }, {
                    default: _withCtx((validationState) => [
                      _createVNode(_component_TextAreaGroup, {
                        placeholder: "20文字以上、200文字以内で入力してください",
                        appLabelText: "必須",
                        modelValue: _ctx.inputValue.suggestionValue,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputValue.suggestionValue) = $event)),
                        validationState: validationState
                      }, null, 8, ["modelValue", "validationState"])
                    ]),
                    _: 1
                  })
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_AppButton, {
                    class: "mt-4 px-5",
                    variant: "danger",
                    onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("退会")
                    ], undefined, true),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createTextVNode(),
                  _createVNode(_component_AppButton, {
                    class: "mt-4 px-5",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.backToMypage()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("戻る")
                    ], undefined, true),
                    _: 1
                  })
                ])
              ], undefined, true),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _createTextVNode(),
    _createVNode(_component_AppFooter),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}